export class InvalidVariantIdError extends Error {
  public name = 'InvalidVariantIdError';

  constructor(message = 'Variant ID is invalid') {
    super(message);
  }
}

export class NoDeliveryEstimateError extends Error {
  public name = 'NoDeliveryEstimateError';
  public requestId: string;

  constructor(
    requestId: string,
    message = 'No delivery estimate returned from API',
  ) {
    super(message);
    this.requestId = requestId;
  }
}
